export enum QtyTypeEnum {
    "<10K"  = '<10K',
    ">10K" = '>10K',
  }
